import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import FinalWinnerSuccesContainer from 'containers/finalWinnerSucces';
import HeaderContainer from '../../containers/header';
import FooterContainer from '../../containers/footer';

const FinalWinnerSuccesPage = () => {
  const { statusDataWinner } = useSelector((state) => state.finalWinner);
  useEffect(() => {
  }, [statusDataWinner]);

  return (
    <>
      <HeaderContainer />
      <FinalWinnerSuccesContainer />
      <FooterContainer />
    </>
  );
};

export default FinalWinnerSuccesPage;
